import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { NavigationService } from '../store/navigation/navigation.service';

/**
 * Guard de la route racine d'un module (ex. `path: 'Crm'`). Résout la page cible via
 * `NavigationService.resolveModuleLandingUrl` : URL par défaut si accessible, sinon
 * première URL réellement accessible du module, plutôt qu'une redirection en dur non
 * vérifiée contre les droits de l'utilisateur.
 *
 * S'exécute après AuthenticationGuard, donc uniquement si authentifié.
 *
 * `data` attendu sur la route : `{ moduleRedirect: string }`.
 */
export const ModuleRedirectGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const router = inject(Router);
  const navigationService = inject(NavigationService);

  const moduleId = route.data['moduleRedirect'] as string;
  // Chemin gardé lui-même (ex. `/Crm`) : à exclure des cibles pour ne pas
  // re-déclencher ce guard en boucle si les menus le contiennent.
  const selfRoute = '/' + (route.routeConfig?.path ?? '');

  return navigationService
    .resolveModuleLandingUrl(moduleId, selfRoute)
    .pipe(map((url) => router.parseUrl(url)));
};
